// import React, { useEffect, useState } from "react";
// import ReactApexChart from "react-apexcharts";
// import BASEURL from "../../Utils/Baseurl";
// import request, { gql } from "graphql-request";
// import "react-loading-skeleton/dist/skeleton.css";
// import BarChatSkelton from "../piechart/BarChatSkelton";

// import ReactApexChart from "react-apexcharts";

// const allUsersQuotationOpportunityCount = gql`
//   query {
//     allUsersQuotationOpportunityCount {
//       username

//       quotationCount

//       opportunityCount
//     }
//   }
// `;
// const ApexChart = () => {
//   //   const series = [
//   //     {
//   //       name: "Net Profit",
//   //       data: [44, 55, 57, 56, 61, 58, 63, 60, 66],
//   //     },
//   //     {
//   //       name: "Revenue",
//   //       data: [76, 85, 101, 98, 87, 105, 91, 114, 94],
//   //     },
//   //     {
//   //       name: "Free Cash Flow",
//   //       data: [35, 41, 36, 26, 45, 48, 52, 53, 41],
//   //     },
//   //   ];
//   const [apiData, setApiData] = useState([]);
//   const [userName, setUserName] = useState([]);
//   const [quotationCounts, setQuotationCounts] = useState([]);
//   const [opportunityCounts, setOpportunityCounts] = useState([]);
//   const series = [
//     {
//       name: "Quotations",
//       data: quotationCounts,
//     },
//     {
//       name: "Opportunities",
//       data: opportunityCounts,
//     },
//   ];
//   const options = {
//     chart: {
//       type: "bar",
//       height: 350,
//       animations: {
//         enabled: true,
//         easing: "easeinout",
//         speed: 800,
//         animateGradually: {
//           enabled: true,
//           delay: 150,
//         },
//         dynamicAnimation: {
//           enabled: true,
//           speed: 350,
//         },
//       },
//     },

//     plotOptions: {
//       bar: {
//         horizontal: false,
//         columnWidth: "55%",
//         endingShape: "rounded",
//       },
//     },
//     dataLabels: {
//       enabled: false,
//     },
//     stroke: {
//       show: true,
//       width: 2,
//       colors: ["transparent"],
//     },
//     xaxis: {
//       categories: userName,
//     },
//     yaxis: {
//       title: {
//         text: "Counts",
//       },
//     },
//     fill: {
//       opacity: 1,
//     },
//     tooltip: {
//       y: {
//         formatter: (val) => `${val} counts`,
//       },
//     },
//   };

//   //   const options = {
//   //     chart: {
//   //       type: "bar",
//   //       height: 350,
//   //     },
//   //     plotOptions: {
//   //       bar: {
//   //         horizontal: false,
//   //         columnWidth: "55%",
//   //         endingShape: "rounded",
//   //       },
//   //     },
//   //     dataLabels: {
//   //       enabled: false,
//   //     },
//   //     stroke: {
//   //       show: true,
//   //       width: 2,
//   //       colors: ["transparent"],
//   //     },
//   //     xaxis: {
//   //       categories: [
//   //         "Feb",
//   //         "Mar",
//   //         "Apr",
//   //         "May",
//   //         "Jun",
//   //         "Jul",
//   //         "Aug",
//   //         "Sep",
//   //         "Oct",
//   //       ],
//   //     },
//   //     yaxis: {
//   //       title: {
//   //         text: "$ (thousands)",
//   //       },
//   //     },
//   //     fill: {
//   //       opacity: 1,
//   //     },
//   //     tooltip: {
//   //       y: {
//   //         formatter: (val) => `$ ${val} thousands`,
//   //       },
//   //     },
//   //   };

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   useEffect(() => {
//     setLoading(true);
//     request(BASEURL, allUsersQuotationOpportunityCount)
//       .then((res) => {
//         setApiData(res.allUsersQuotationOpportunityCount);
//         const data = res.allUsersQuotationOpportunityCount;
//         const usernames = data.map((item) => item.username);
//         const quotationCounts1 = data.map((item) => item.quotationCount);
//         const opportunityCounts1 = data.map((item) => item.opportunityCount);
//         setUserName(usernames);
//         setQuotationCounts(quotationCounts1);
//         setOpportunityCounts(opportunityCounts1);
//       })
//       .finally(() => setLoading(false));
//   }, []);

//   const renderContent = () => {
//     if (loading) return <BarChatSkelton />;
//     if (error)
//       return <p style={{ color: "red", textAlign: "center" }}>{error}</p>;
//     if (apiData.length === 0)
//       return (
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             width: "100%",
//             margin: "10px 0px",
//           }}
//         >
//           <p>No Scheduled Appointment</p>
//         </div>
//       );

//     return (
//       <div
//         style={{
//           width: "100%",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           margin: "10px 0px",
//         }}
//       >
//         <div id="chart">
//           <ReactApexChart
//             options={options}
//             series={series}
//             type="bar"
//             height={350}
//             width={430}
//           />
//         </div>
//         <div id="html-dist"></div>
//       </div>
//     );
//   };

//   return (
//     <div>
//       {/* <div id="chart">
//         <ReactApexChart
//           options={options}
//           series={series}
//           type="bar"
//           height={350}
//         />
//       </div>
//       <div id="html-dist"></div> */}
//       {renderContent()}
//     </div>
//   );
// };

// export default ApexChart;



import React, { useState } from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import ReactApexChart from "react-apexcharts";

const ApexChart = () => {
  const isMobile = useMediaQuery("(max-width: 768px)"); // Responsive check

  const [state] = useState({
    series: [48.9, 38.65, 18.2, 7.06],
    options: {
      chart: {
        type: "donut",
      },
      labels: [
        "Warehouse Management",
        "Human Resource Management",
        "Customer Relationship Management",
        "Accounts Management",
      ],
      colors: ["#00A91F", "#FF8900", "#0091CA", "#8E00B4"],
      legend: {
        show: false, // Hide default ApexChart legend
      },
      plotOptions: {
        pie: {
          donut: {
            size: isMobile ? "75%" : "65%", // Adjust pie size for mobile
            labels: {
              show: false, // Hide labels inside the pie chart
            },
          },
        },
      },
      dataLabels: {
        enabled: false, // Disable value labels inside the chart
      },
      tooltip: {
        enabled: true, // Enable tooltips on hover
      },
      stroke: {
        show: true,
        width: 2, // Creates a slight border effect
        colors: ["#fff"], // White border between segments
      },
    },
  });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row", // Stack layout for mobile
        alignItems: "center",
        justifyContent: isMobile ? "center" : "space-between",
        bgcolor: "#fff",
        borderRadius: 3,
        boxShadow:"0px 0px 10px 0px #0000001A",
        p: 2,
        fontFamily: "Aptos",
        width: "100%",
        height: {md:'100%',lg:"250px"},
      }}
    >
      {/* Donut Chart */}
      <Box width={isMobile ? "100%" : "40%"} textAlign="center">
        <ReactApexChart options={state.options} series={state.series} type="donut" width={"100%"} />
      </Box>

      {/* Custom Legend with Values */}
      <Box
        sx={{
          width: isMobile ? "100%" : "60%",
          mt: isMobile ? 2 : 0,
          textAlign: isMobile ? "center" : "left",
        }}
      >
        <Typography variant="h6" sx={{ fontFamily:'Aptos',color:'#000', fontWeight: "bold", mb: 1 }}>
          Sales By Category
        </Typography>
        {state.options.labels.map((item, index) => (
          <Box key={index} display="flex" alignItems="center" justifyContent="space-between" mb={0.5}>
            <Box display="flex" alignItems="center">
              <Box
                sx={{
                  width: 12,
                  height: 12,
                  backgroundColor: state.options.colors[index],
                  borderRadius: "50%",
                  mr: 1,
                }}
              />
              <Typography variant="body2" sx={{fontSize:{xs:'14px',lg:'15px'} }} >{item}</Typography>
            </Box>
            <Typography variant="body2" sx={{fontSize:{xs:'13px',lg:'15px'}, fontWeight: "bold" ,pr:1.5 }}>
              {state.series[index]}%
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ApexChart;
